<div class="modal fade" id="dialogAudespPacoteList" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white" style="justify-content: flex-start;">
        <i class="fa fa-box fa-2x mr-2"></i>
        <h3 class="mt-1 mb-0">AUDESP - FASE 4 [Pacotes]</h3>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-5">
            <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
            </lib-filtro>
          </div>
        </div>
        <div class="row" *ngIf="lista && lista.length > 0">
          <div class="col-md-3" *ngFor="let item of lista" style="padding: 10px;">
            <div class="card">
              <div class="card-header">
                <span>Pacote #{{item.id}}</span>
                <button class="btn btn-sm btn-outline-secondary" style="position: absolute; right: 10px;"
                  (click)="visualizar(item.id)">
                  <i class="fa fa-search"></i>
                </button>
              </div>
              <div class="card-body p-1">
                <ul class="list-group list-group-flush small">
                  <li class="list-group-item p-1">
                    {{item.tipo}}
                  </li>
                  <li class="list-group-item p-1">
                    {{item.data_cadastro | date:'dd/MM/yyyy HH:mm'}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row float-right" *ngIf="lista && lista.length > 0">
          <div class="col-12 mb-5">
            <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
              (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-link text-muted" data-dismiss="modal">Fechar</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="dialogAudespPacoteForm" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content" *ngIf="pacoteAtual">
      <div class="modal-header bg-primary text-white" style="justify-content: flex-start;">
        <i class="fa fa-box-open fa-2x mr-2"></i>
        <h3 class="mt-1 mb-0">AUDESP - FASE 4 [Pacote Nº #{{pacoteAtual.id}}]</h3>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header" style="justify-content: space-between;">
                <span>Tipo de Arquivo: {{pacoteAtual.tipo}}</span>
                <span>Data da criação: {{pacoteAtual.data_cadastro | date:'dd/MM/yyyy HH:mm'}}</span>
              </div>
              <div class="card-body p-1">
                <div class="table-responsive">
                  <table class="table table-eddy table-sm">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 120px;" class="text-center">Código</th>
                        <th scope="col">Identificação</th>
                        <th scope="col" style="width: 70px;"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of pacoteAtual.arquivos">
                        <th scope="row" class="text-center">
                          {{item.codigo}}
                        </th>
                        <td>{{item.identificacao}}</td>
                        <td class="text-muted" style="font-size: 1.2rem">
                          <i [class]="'fa fa-arrow-circle-down' + (item.exportado ? ' text-primary' : '')"
                            [title]="(item.exportado ? '' : 'Não ') + 'Exportado'"></i>
                          <i [class]="'fa fa-arrow-circle-up' + (item.enviado ? ' text-primary' : '')"
                            [title]="(item.enviado ? '' : 'Não ') + 'Enviado'"></i>
                          <i [class]="'fa fa-check-circle' + (item.armazenado ? ' text-success' : '')"
                            [title]="(item.armazenado ? '' : 'Não ') + 'Armazenado'"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-link text-muted" data-dismiss="modal">Fechar</button>
        <a (click)="baixarPacote()" class="btn btn-sm btn-secondary float-right ml-2">
          <i class="fa fa-download"></i> Baixar pacote
        </a>
        <a *ngIf="!pacoteAtual.enviado" (click)="enviarPacote()" class="btn btn-sm btn-primary float-right ml-2">
          <i class="fa fa-arrow-up"></i> Enviar pacote
        </a>
      </div>
    </div>
  </div>
</div>